import { useQuery } from "react-query";

import { Nullable, UUID } from "foundation-ts/types";
import { SectionCategory, SessionActorType } from "@bcasmart/doxecure-commons/doxecureTypes";
import { SessionsQueryRestrictions } from "@bcasmart/doxecure-commons/doxecureClientTypes";

import { SectionsListQueryID } from "@hooks/hooksConstants";
import { getSectionsForUser } from "@services/session.service";

const useSections = (
    userID: Nullable<UUID>, 
    roles: SessionActorType|SessionActorType[], 
    restrictions?:SessionsQueryRestrictions, 
    category?: SectionCategory, 
    searchString?: string,
    nocookie?: boolean) =>
    
    useQuery([SectionsListQueryID, userID, roles, category,searchString], () => getSectionsForUser(userID, roles, restrictions, category, searchString, nocookie));

export default useSections;
